import { render } from "./file-recent.vue?vue&type=template&id=17f4c302"
import script from "./file-recent.vue?vue&type=script&lang=js"
export * from "./file-recent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__